import type { ComponentType } from 'react';

/**
 * UI that exists only in mock builds. main.tsx registers it before the first render behind the
 * `VITE_API_MOCK` flag, so production bundles never import the components themselves.
 */
export const mockOnly: { DemoDataPicker: ComponentType | null } = { DemoDataPicker: null };
